<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-20 16:27:11
-->
<template>
  <div class="contain">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="80%"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <section class="head">
        <div>
          <img src="@/assets/images/企业icon@2x.png" alt="" />
        </div>
        <div>
          <div>{{ entData.entName }}</div>
          <div>
            <div>统一社会信用代码：{{ entData.creditCode }}</div>
            <div>法人：{{ entData.frName }}</div>
            <div>
              注册地址：
              {{ entData.address }}
            </div>
          </div>
          <div>
            <div v-for="item in labelName" :key="item">{{ item }}</div>
          </div>
        </div>
      </section>
      <section class="tab">
        <div
          v-for="item in tabList"
          :key="item.value"
          @click="onChoiceEnt(item.value)"
          :class="{ act: item.value == componentId }"
        >
          {{ item.name }}
        </div>
      </section>
      <section class="content">
        <component
          :is="componentId"
          :entName="entName"
          :creditCode="creditCode"
          ref="view"
        ></component>
      </section>
    </el-dialog>
  </div>
</template>

<script>
import { getEntDetail } from '@api/corporateInteraction/enterprise'
import businessInformationView from './businessInformation.vue'
import companyPagesView from './companyPages.vue'
import enterpriseDemandsView from './enterpriseDemands.vue'
import managementInformationView from './managementInformation.vue'
import patentInformationView from './patentInformation.vue'
import serviceOrderView from './serviceOrder.vue'
export default {
  props: {
    entName: {
      type: String,
      default: ''
    },
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {
    businessInformationView,
    companyPagesView,
    enterpriseDemandsView,
    managementInformationView,
    patentInformationView,
    serviceOrderView
  },
  data() {
    return {
      dialogVisible: false,
      entData: {},
      labelName: [],
      componentId: 'companyPagesView',
      tabList: [
        { name: '企业主页', value: 'companyPagesView' },
        { name: '工商信息', value: 'businessInformationView' },
        { name: '经营信息', value: 'managementInformationView' },
        { name: '专利信息', value: 'patentInformationView' },
        { name: '企业诉求', value: 'enterpriseDemandsView' },
        { name: '服务订单', value: 'serviceOrderView' }
      ]
    }
  },
  watch: {
    creditCode(val) {
      if (val) {
        this.getEntInformation(val)
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    changeShow() {
      this.dialogVisible = true
    },
    getEntInformation(val) {
      getEntDetail({ creditCode: val }).then(res => {
        if (res.data.code == '0000') {
          this.entData = res.data.data.entData || {}
          this.labelName = res.data.data.labelName || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChoiceEnt(val) {
      this.componentId = val
    },
    handleClose() {
      this.dialogVisible = false
      this.componentId = 'companyPagesView'
    }
  }
}
</script>
<style lang="scss">
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
</style>
<style lang="scss" scoped>
.contain {
  /deep/ .el-dialog {
    margin-top: 1rem !important;
    height: 85%;
    font-size: 0.16rem;
    background: url('~@assets/images/弹窗外框.png') no-repeat;
    background-size: 100% 100%;
    .el-dialog__close {
      font-size: 0.22rem;
      color: rgba(255, 255, 255, 0.85);
    }
    .el-dialog__body {
      margin-top: 0.15rem;
      padding: 0 0.4rem;
      .head {
        height: 1.6rem;
        background: url('~@assets/images/头部企业信息背景框.png') no-repeat;
        background-size: 100% 100%;
        padding: 0.28rem;
        display: flex;
        color: rgba(255, 255, 255, 0.85);
        align-items: center;
        & > div:nth-child(1) {
          img {
            width: 0.8rem;
          }
        }
        & > div:nth-child(2) {
          margin-left: 0.15rem;
          & > div:nth-child(1) {
            font-size: 22px;
            color: rgba(0, 255, 254, 100);
          }
          & > div:nth-child(2) {
            display: flex;
            font-size: 0.16rem;
            margin: 0.15rem 0;
            & > div {
              margin-right: 0.15rem;
            }
          }
          & > div:nth-child(3) {
            display: flex;
            font-size: 0.14rem;
            & > div {
              padding: 0.04rem 0.08rem;
              border: 1px solid rgba(255, 255, 255, 0.25);
              margin-right: 0.08rem;
            }
          }
        }
      }
      .tab {
        margin-top: 0.32rem;
        color: rgba(255, 255, 255, 0.85);
        display: flex;
        .act {
          color: rgba(0, 255, 254, 100);
          box-shadow: inset 0px 0px 9px 0px rgba(0, 255, 254, 1);
        }
        & > div {
          cursor: pointer;
          padding: 0.08rem 0.16rem;
        }
      }
      .content {
        height: 5rem;
        overflow: auto;
      }
    }
  }
}
</style>
